module.exports = __webpack_public_path__ + "static/media/IMG_9050.63684f85.JPG";